'use client';

import useMediaQuery from '@package/hooks/src/useMediaQuery';
import { useMemo } from 'react';

import Carousel from './Carousel';
import { ResponsiveCarouselProps, DefaultValue } from './types';

export default function ResponsiveCarousel<V = DefaultValue>(props: ResponsiveCarouselProps<V>) {
  const { visibleSlidesQuery, hideDotButtons, hideArrow, ...rest } = props;

  const xxl: boolean = useMediaQuery('(min-width:1280px)');
  const xl: boolean = useMediaQuery('(min-width:1024px)');
  const lg: boolean = useMediaQuery('(min-width:960px)');
  const md: boolean = useMediaQuery('(min-width:768px)');
  const sm: boolean = useMediaQuery('(min-width:425px)');

  const visibleSlides: number = useMemo((): number => {
    if (xxl) return visibleSlidesQuery.xxl;
    if (xl) return visibleSlidesQuery.xl;
    if (lg) return visibleSlidesQuery.lg;
    if (md) return visibleSlidesQuery.md;
    if (sm) return visibleSlidesQuery.sm;
    return visibleSlidesQuery.xs;
  }, [xxl, xl, lg, md, sm, visibleSlidesQuery]);

  const allElementVisible = useMemo(() => rest.slideData.length <= visibleSlides, [rest.slideData, visibleSlides]);

  return (
    <Carousel<V>
      {...rest}
      visibleSlides={visibleSlides}
      hideButtons={allElementVisible || hideArrow}
      hideDotButtons={hideDotButtons || allElementVisible}
      disableDrag={allElementVisible}
    />
  );
}
